export default {
      id: "icon--slider-arrow-usage",
      viewBox: "0 0 8 15",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--slider-arrow-usage",
      toString: function () {
        return this.url;
      }
    }